<template>
  <div>
    <div class="row col-md-12" id="tabs" style="margin: -3px 0 0 0;  border-bottom: 1px solid #93a8d6;">
      <div class="form-group mb-0 ml-1" id="tab_list">
        <ul class="nav nav-pills" role="tablist" id="tabs" style="font-size: 14px; font-weight: 500">
          <li class="nav-item type1 mr-4">
            <a class="nav-link demo" v-bind:class="[selectTab == 0 ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus(0)" @click="taskStatus(0)">Pending</a>
          </li>
          <li class="nav-item type1 mr-4">
            <a class="nav-link demo" v-bind:class="[selectTab == 1 ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus(1)" @click="taskStatus(1)">Completed</a>
          </li>
        </ul>
      </div>
      <div class="float-right ml-auto" style="margin-top: 6px" id="support_filter">
        <div class="float-left mr-3">
          <div class="has-search">
            <span class="fa fa-search form-control-feedback"></span>
            <input v-model="search" @keyup="taskSearch" type="text" style="background-color: #edf2f5"
                   class="form-control search" placeholder="Search Here..." />
          </div>
        </div>
        <!-- Filter Button-->
        <button class="btn btn-sm filter" style="border: 1px solid #48a6a6;padding: 6px 8px 3px 8px;" type="button" data-toggle="collapse"
                data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"  v-on:click="ShowFilter">
          <i class="fa fa-filter" style="font-size:19px;color:#48a6a6;"></i>
        </button>

        <button @click="createTask" type="button" class="btn btn-sm float-right ml-2" style="
            color: white;
            padding: 5px 10px;
            cursor: pointer;
            border: 1px solid #48a6a6;
            padding: 7px 8px 3px 9px;
          ">
          <span class="fa fa-plus" style="font-size:18px;color:#48a6a6;"></span>
        </button>
        <!-- <router-link v-if="$route.fullPath == '/development-tasks'" to="/development-tasks/new-task" class="btn float-right ml-2 add-ticket" id="add_new_default" style="  padding: 5px 8px 2px 8px;"> <span  style="font-size:20px;color:#48a6a6"  class="fa fa-plus"></span></router-link> -->
      </div>
    </div>
    <div :class="show_filter" class="row collapse filter-button px-3" id="collapseExample">
      <div class="col-sm-12 col-md-3" >
        <div class="form-group">
          <label style="color: #48a6a6; font-weight: 600; font-size: 14px">{{ isMyTask ? 'Assign To' : 'Assigned By' }}</label>
          <multiselect  :options="assignTo" :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" v-model="assign_to_users"
                        :multiple="true" label="user_name" track-by="id" style="font-size:12px !important" placeholder="All Users">
          </multiselect>
        </div>
      </div>
     <div class="col-sm-12 col-md-3" >
       <div class="form-group" style="display:flex; flex-direction:column;">
         <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Due Date</label>
         <date-range-picker v-model="dateRange"></date-range-picker>
       </div>
     </div>


      <div class="col-sm-12 col-md-6 " style=" display: flex; justify-content: right;  padding: 22px 17px 0px 0px;">
        <button type="button" class="btn btn-basic right mt-3 bg-green-default reset-button" style="margin: 0% 0% 5% 0%;">
          <span class="reset" @click="resetFilter"> Reset</span>
        </button>
      </div>

    </div>

  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import VueSkeletonLoader from 'skeleton-loader-vue';
import taskForm from "@/components/QuickTask/add.vue";
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
export default {
  components: {
    Multiselect, VueSkeletonLoader,DateRangePicker
  },

  data() {
    return{
      selectTab: 0,
      search: '',
      show_filter: false,
      assign_to_users: [],
      status:'',
      dateRange:{},
      filters: {
        assign_users: [],
        start_date: '',
        end_date: ''
      }
    }
  },
  computed: {

    isMyTask() {
      return this.$route.meta.taskType === 'myTask';
    },

    show_filter: function () {
      localStorage.getItem('show_filter');
    },
    assignTo() {
      return this.$store.getters['users/assignToUser'];
    }
  },
  mounted() {
     this.selectTab = this.$store.getters['quick_task/status'];
  },
  watch:{
    assign_to_users: function(){
      this.filters.assign_users = this.assign_to_users.map(({ id }) => id);
      this.getRecords();
    },

    dateRange: function(){
      this.filters.start_date = this.dateRange.startDate;
       this.filters.end_date = this.dateRange.endDate;
       
      this.getRecords();
    }
  },
  methods:{

    taskSearch() {
      if (this.search.replace(/\s/g, "").length || this.search == '') {
        // this.filters.search = this.this.search;
        this.getRecords();
      }
    },
    ShowFilter(){
      this.show_filter == 'show' ?  localStorage.setItem('show_filter', false) :  localStorage.setItem('show_filter', 'show');
    },
    createTask() {
      this.$store.dispatch("modal/quicktaskModal", {
        action: "create",
        title: "Add Quick Task",
        show:true,
        formData: {
          developers: this.developers,
        },
        component: taskForm
      });
    },
    selectedStatus(event) {
      this.$emit("selectQuickTaskTab", event);
    },

    taskStatus(event) {
      this.selectTab = event;
      this.status = event;
      this.getRecords();
    },
    getRecords(){
      this.$emit('update-parent-filters', this.filters);
      this.$emit('set-search', this.search);
      this.$emit('setQuickTaskStatus', this.status);
      // this.skeletonLoader = true;
      this.$parent.getRecords()
    },

    resetFilter() {
      // Reset all filters
      this.search = '';
      this.assign_to_users = [];
      this.dateRange = {};
      this.filters.assign_users = [];
      this.filters.start_date = '';
      this.filters.end_date = '';
      this.status = 0;

      this.getRecords();
    }
  }

}

</script>
<style >
#tabs .nav-link {
  background: transparent;
  color: rgb(66, 64, 64);
}
#tabs .active {
  background-color: #48a6a6 !important;
  color: white;
}
.daterangepicker.openscenter{
  left: 0% !important;
  transform: translate(-64%) !important;
}
.cancelBtn.btn.btn-sm.btn-secondary:hover{
  color: gray !important;
}
.applyBtn.btn.btn-sm.btn-success{
  background-color: #48a6a6  !important;
}
.applyBtn.btn.btn-sm.btn-success:hover{
  color: #48a6a6  !important;
  border-color: #48a6a6 !important;
  background-color: white !important;
}
.form-control.search{
  height: calc(1.5em + 0.65rem + 0px) !important;
}


</style>